import { gql } from 'graphql-request'

export const GET_WRITER_SALES_ANALYTICS_EBOOK_DETAIL = gql`
  query GetWriterSalesAnalyticsEbookDetail(
    $getWriterSalesAnalyticsEbookDetailInput: GetWriterSalesAnalyticsEbookDetailInput!
  ) {
    getWriterSalesAnalyticsEbookDetail(
      getWriterSalesAnalyticsEbookDetailInput: $getWriterSalesAnalyticsEbookDetailInput
    ) {
      graphData {
        date
        value
      }
      graphType
      tableData {
        discountedPrice
        ebookTitle
        promotionDiscountValue
        promotionEndedAt
        promotionType
        promotionStartedAt
        rawPrice
        total
        promotionStatus
        penName
        coverImgPath
        category
      }
    }
  }
`
